import { alpha, Components, Theme } from "@mui/material/styles";
import { GREY } from "./palette";
import { cardShadow, dropdownShadow, dialogShadow, primaryShadow } from "./shadows";

export function componentsOverrides(theme: Theme): Components<Theme> {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        "*": { boxSizing: "border-box" },
        html: { WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" },
        body: { minHeight: "100%" },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          position: "relative",
          zIndex: 0,
          borderRadius: 16,
          boxShadow: cardShadow,
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: { padding: theme.spacing(3) },
      },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: { backgroundImage: "none" },
        outlined: { borderColor: alpha(GREY[500], 0.16) },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 8, fontWeight: 700 },
        sizeLarge: { minHeight: 48 },
        containedPrimary: {
          boxShadow: primaryShadow,
          "&:hover": { boxShadow: "none" },
        },
        outlinedInherit: {
          border: `1px solid ${alpha(GREY[500], 0.32)}`,
          "&:hover": { backgroundColor: alpha(GREY[500], 0.08) },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600, borderRadius: 8 },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { boxShadow: "none" },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          "& .MuiOutlinedInput-notchedOutline": { borderColor: alpha(GREY[500], 0.32) },
          "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: GREY[600] },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-head": {
            backgroundColor: GREY[200],
            color: GREY[600],
            fontWeight: 700,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderBottomColor: alpha(GREY[500], 0.16) },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { backgroundColor: GREY[800], borderRadius: 6 },
        arrow: { color: GREY[800] },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: { borderRadius: 10, boxShadow: dropdownShadow },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: { borderRadius: 10, boxShadow: dropdownShadow },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 16, boxShadow: dialogShadow },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        line: { borderColor: alpha(GREY[500], 0.24) },
      },
    },
  };
}
